export default __webpack_public_path__ + "static/media/thunderstorm.0bc57389.mp4";